const toFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const getArmorItems = (items = []) =>
  items.filter((item) => item.type?.toLowerCase() === "armor");

export const calculateArmorClass = (characteristics = {}, items = []) => {
  const baseArmorClass = toFiniteNumber(
    characteristics.baseArmorClass ?? characteristics.armorClass
  );
  const additionalModifier = toFiniteNumber(
    characteristics.additionalArmorClassModifier
  );
  const equipmentModifier = getArmorItems(items)
    .filter((item) => item.isActive)
    .reduce((total, item) => total + toFiniteNumber(item.armorClass), 0);

  return baseArmorClass + equipmentModifier + additionalModifier;
};
